import React from "react";
//#region types
import { ExpandableListItemFilterProps } from "models/propTypes/listPropTypes";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Divider, Grid } from "@mui/material";
import ActionLinkButton from "../buttons/actionLinkButton";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ExpandableListItemFilter: React.FC<ExpandableListItemFilterProps> = (props) => {
  const onClick = (id: string | number, event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    const selectedItems = props.selectedItems ?? [];
    const itemIndex = selectedItems.findIndex((s) => s === id);
    const updatedSelection = [...selectedItems];
    if (itemIndex > -1) {
      updatedSelection.splice(itemIndex, 1);
    } else {
      updatedSelection.push(id);
    }

    props.filterFunc(props.items.filter((i) => updatedSelection.some((s) => s === i.id)));
  };

  return (
    <>
      {props.items.length > 1 ? (
        <Grid item className={cssExports.expandableListItemFilters}>
          <Grid container>
            {props.items.map((action, index) => (
              <Grid item key={index}>
                <Divider orientation="vertical" variant="middle" flexItem className={cssExports.actionDivider} />
                {(props.selectedItems ?? []).findIndex((i) => i === action.id) > -1 ? (
                  <ActionLinkButton
                    startIcon={<Icon icon={IconDefinitionConstants.WCheck} />}
                    className={cssExports.toggledFilter}
                    onClick={onClick.bind(null, action.id)}
                  >
                    {action.value}
                  </ActionLinkButton>
                ) : (
                  <ActionLinkButton onClick={onClick.bind(null, action.id)}>{action.value}</ActionLinkButton>
                )}
              </Grid>
            ))}
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
};

export default ExpandableListItemFilter;
